<template>
  <div v-touch:swipe="swipeItem" v-touch:tap="tabItem" @mouseover="overSlide" @mouseout="outSlide" :class="(controls && items.length > 1 && !hasTouch)? 'container-fluid tinkSlide' : 'container-fluid tinkSlideNoControl'" :id="'tinkSlide_' + _uid">

    <div v-if="controls && controlPrev && items.length > 1" :class="(controlPrevClass)? `tinkSlidePrevControl ${controlPrevClass}` : `tinkSlidePrevControl`" :id="'tinkSlidePrevControl_' + _uid" @click="previusItem">
      <slot name="controlPrev">
        <b-button size="sm" :id="'tinkSlidePrevControlButton_' + _uid" class="p-0 pl-1 pr-1">&#9664;</b-button>
      </slot>
    </div>

    <div v-if="controls && controlNext && items.length > 1" :class="(controlNextClass)? `tinkSlideNextControl ${controlNextClass}` : `tinkSlideNextControl`" :id="'tinkSlideNextControl_' + _uid"  @click="nextItem">
      <slot name="controlNext">
        <b-button size="sm" :id="'tinkSlideNextControlButton_' + _uid" class="p-0 pl-1 pr-1">&#9654;</b-button>
      </slot>
    </div>
    <!--div class="tinkSlidePrevControl" style="visibility: visible;">
      {{ showIndex }}
    </div-->
    <slot></slot>
  </div>
</template>
<script>

  import uiUtil from "@/mixins/util.js"

  export const tinkSlide = {
    name: "tinkSlide",
    mixins: [uiUtil],
    props: {
      "autoRotate": {
        type: Number,
        default: 0
      },
      "onHeightChange": {
        type: Function,
        default: null
      },
      "swipeDisabled" : {
        type: Boolean,
        default: false,
      },
      "swipeLeftDisabled" : {
        type: Boolean,
        default: false,
      },
      "swipeRightDisabled" : {
        type: Boolean,
        default: false,
      },
      "tabDisabled" : {
        type: Boolean,
        default: false,
      },
      "mouseoutHideControls": {
        type: Boolean,
        default: true
      },
      "controls": {
        type: Boolean,
        default: true
      },
      "controlPrev": {
        type: Boolean,
        default: true
      },
      "controlNext": {
        type: Boolean,
        default: true
      },
      "controlsPosition": {
        type: String,
        default: "middle"
      },
      "controlsHeight": {
        type: Number,
        default: 0.5
      },
      "controlPrevClass": String,
      "controlNextClass": String,
    },
    data: function() {
      return {
        items: [],
        itemHeight: -1,
        showIndex: -1,
        pauseRotate: false,
        rotateTimer: null,
      }
    },
    mounted: function() {

      this.items.forEach((item, index)=> {
        item.$el.display = "none";
        if(item.show) {
          this.showIndex = index;
        }
      });

      if(this.showIndex == -1) {
        if(this.items.length != 0) {
          this.showIndex = 0;
          this.items[0].$el.style.display = "block";
        }
      }
      else {
        this.items[this.showIndex].$el.style.display = "block";
      }

      this.setControlsPosition();

      if(this.showIndex != -1) {
        this.itemHeight = this.height(this.items[this.showIndex].$el);
      }

      if(this.autoRotate >= 3000) {
        this.rotateTimer = window.setInterval(() => {
          this.autoNextItem();
        }, this.autoRotate);
      }
    },
    updated() {
      this.$log.debug("tinkSlide updated");
      this.setControlsPosition();

      if(this.autoRotate >= 3000 && this.rotateTimer == null) {
        this.rotateTimer = window.setInterval(() => {
          this.autoNextItem();
        }, this.autoRotate);
      }

    },
    destroyed() {
      this.$log.debug("tinkSlide destroyed");
    },
    methods: {
      outSlide: function() {
        this.pauseRotate = false;
        if(this.mouseoutHideControls) this.hideControls();
      },
      overSlide: function() {
        this.pauseRotate = true;
        if(this.mouseoutHideControls) this.showControls();
      },
      showControls: function() {
        if(this.controls) {
          let controlPrevEl = (this.controlPrev)? window.document.getElementById("tinkSlidePrevControl_" + this._uid): null;
          let controlNextEl = (this.controlNext)? window.document.getElementById("tinkSlideNextControl_" + this._uid): null;
          if(controlPrevEl) {
            controlPrevEl.style.visibility = "visible";
          }
          if(controlNextEl) {
            controlNextEl.style.visibility = "visible";
          }
        }
      },
      hideControls: function() {
        if(this.controls) {
          let controlPrevEl = (this.controlPrev)? window.document.getElementById("tinkSlidePrevControl_" + this._uid): null;
          let controlNextEl = (this.controlNext)? window.document.getElementById("tinkSlideNextControl_" + this._uid): null;
          if(controlPrevEl) {
            controlPrevEl.style.visibility = "hidden";
          }
          if(controlNextEl) {
            controlNextEl.style.visibility = "hidden";
          }
        }
      },
      autoNextItem: function() {
        if(!this.pauseRotate) {
          this.nextItem();
        }
      },
      tabItem: function(evt) {
        if(!evt || evt.srcElement.tagName.toLowerCase() != "button") {
          if(!this.tabDisabled) {
            this.nextItem(evt);
            if(this.autoRotate >= 3000 && this.rotateTimer != null) {
              window.clearInterval(this.rotateTimer);
              this.rotateTimer = window.setInterval(() => {
                this.autoNextItem();
              }, this.autoRotate);
            }
          }
        }
      },
      swipeItem: function(direction) {
        if(direction == "left" && !this.swipeLeftDisabled && !this.swipeDisabled) {
          this.previusItem();
        }
        else if(direction == "right" && !this.swipeRightDisabled && !this.swipeDisabled) {
          this.nextItem();
        }
      },
      showItemByName: function(name) {
        this.items.forEach((item,index) => {
          if(item.name == name) {
            this.showItem(index);
          }
        });
      },
      showItem: function(index) {
        if(index != -1 && index < this.items.length && this.showIndex != index) {
          let beforeHeight = this.itemHeight
          this.items[this.showIndex].$el.style.display = "none";
          this.showIndex = index;
          this.items[this.showIndex].$el.style.display = "block";
          this.itemHeight = this.height(this.items[this.showIndex].$el);
          if(beforeHeight != this.itemHeight && this.onHeightChange != null) {
            this.onHeightChange(this);
          }
        }
      },
      nextItem: function(evt) {
        if(this.items.length == 0) {
          this.showIndex = -1;
        }
        else if(this.showIndex != -1) {
          if(this.showIndex >= (this.items.length - 1)) {
            this.showItem(0);
          }
          else {
            this.showItem(this.showIndex + 1);
          }
        }
        if(evt) evt.stopPropagation();
      },
      previusItem: function(evt) {
        if(this.items.length == 0) {
          this.showIndex = -1;
        }
        else if(this.showIndex != -1) {
          if(this.showIndex == 0) {
            this.showItem(this.items.length - 1);
          }
          else {
            this.showItem(this.showIndex - 1);
          }
        }
        if(evt) evt.stopPropagation();
      },

      setControlsPosition: function() {

        if(this.controls && (this.controlPrev || this.controlNext) && this.items.length > 1) {
          window.setTimeout(() => {
            try {

              let boxEl = window.document.getElementById("tinkSlide_" + this._uid);

              if(boxEl != null) {
                let controlPrevEl = (this.controlPrev)? window.document.getElementById("tinkSlidePrevControl_" + this._uid): null;

                let controlNextEl = (this.controlNext)? window.document.getElementById("tinkSlideNextControl_" + this._uid): null;

                if(this.controlsPosition != "custom" && this.controlsHeight >= 0) {
                  if(this.controlPrev) {
                    controlPrevEl.style.height = this.height(boxEl)*this.controlsHeight + "px";
                  }
                  if(this.controlNext) {
                    controlNextEl.style.height = this.height(boxEl)*this.controlsHeight + "px";
                  }
                }

                if(this.controlsPosition == "top") {
                  if(controlPrevEl != null) {
                    controlPrevEl.style.top = "0px";
                  }
                  if(controlNextEl != null) {
                    controlNextEl.style.top = "0px";
                  }
                }
                else if(this.controlsPosition == "middle") {
                  if(controlPrevEl != null) {
                    controlPrevEl.style.top = ( this.height(boxEl)/2 - this.height(controlPrevEl)/2 ) + "px";
                  }
                  if(controlNextEl != null) {
                    controlNextEl.style.top = ( this.height(boxEl)/2 - this.height(controlNextEl)/2 ) + "px";
                  }
                }
                else if(this.controlsPosition == "bottom") {
                  if(controlPrevEl != null) {
                    controlPrevEl.style.top = ( this.height(boxEl) - this.height(controlPrevEl) ) + "px";
                  }
                  if(controlNextEl != null) {
                    controlNextEl.style.top = ( this.height(boxEl) - this.height(controlNextEl) ) + "px";
                  }
                }

                if(controlPrevEl != null) {
                  if(!this.mouseoutHideControls) controlPrevEl.style.visibility = "visible";
                }

                if(controlNextEl != null) {
                  if(!this.mouseoutHideControls) controlNextEl.style.visibility = "visible";
                }
              }
            }
            catch(error) {
              this.$log.debug("error", error);
            }
          }, 100);
        }
      }
    }
  }
  export { default as tinkSlideItem } from './tinkSlideItem.vue';
  export default tinkSlide;

</script>
<style>

  .tinkSlidePrevControl {
    position: absolute;
    left: 0.25rem;
    visibility: hidden;
    text-align: center;
  }

  .tinkSlideNextControl {
    position: absolute;
    right: 0.25rem;
    visibility: hidden;
    text-align: center;
  }

  .tinkSlidePrevControl button {
    font-size: 0.5rem; opacity : 0.5; height:100%; width: 100%;
  }

  .tinkSlideNextControl button {
    font-size: 0.5rem; opacity : 0.5; height:100%; width: 100%;
  }

  .tinkSlide {
    position: relative;
    overflow: hidden;
    padding: 0.5rem 0rem 0.5rem 0.5rem;
    z-index: 1000;
  }

  .tinkSlideNoControl {
    position: relative;
    overflow: hidden;
    padding: 0.5rem 0rem 0.5rem 0.5rem;
    z-index: 1000;
  }

</style>
